import { CRMTypes } from '@labrav/common'
import {
  deleteSingleReferralTemplate,
  deleteTemplateSalesforce,
} from '../../../api/mappingManager'

export const deleteMarketplaceTemplateAPI = async ({
  crmId,
  templateId,
  crmType,
  accountId,
  useMappingService,
}: {
  crmId: string
  templateId: string
  crmType?: CRMTypes
  accountId?: string
  useMappingService?: boolean
}) => {
  if (crmType === CRMTypes.salesforce || useMappingService) {
    return await deleteTemplateSalesforce(crmId, accountId ?? '', templateId)
  }

  return await deleteSingleReferralTemplate(crmId, templateId)
}
